export enum UserDocumentUrl {
  BrUrl = 'businessRegistrationUrl',
  NicUrl = 'nicUrl',
  NvqUrl = 'nvqCertificateUrl',
}
